<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-31 17:55:03
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-09-07 13:45:08
 * @FilePath: \vue-hepha-order\src\views\base\OrderSource.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="priceContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>
        
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >

            <template v-slot:columns="{ props }">
                <div v-if="props.column.key == 'type'">
                    <a-tag :color="props.record.type_val == 0? 'blue' : 'green' ">{{ props.record.type }}</a-tag>
                </div>
            </template>

            <template v-slot:operate>
                <a-button 
                    v-permission="'setting.financial.syncERPPrice'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('syncERPPrice')"
                >
                    <icon-sync size="13" style="marginRight:5px;"/>
                    {{ $t('financial.syncERPPrice') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.financial.syncERPPrice'" />
                <a-button 
                    v-permission="'setting.financial.exportPriceData'" 
                    size="mini" class="form_btn" type="primary" 
                    @click="handle('exportPriceData')"
                >
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('financial.exportPriceData') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.financial.exportPriceData'" />
                <a-alert class="alertBar">
                    <span>{{ $t('financial.syncTip') }}</span>
                </a-alert>
            </template>
        </Table>

        <!-- 同步ERP价目表 -->
        <a-modal
            :title="modalTitle"
            v-model:visible="visible" 
            width="30%"
            draggable
            :render-to-body="false"
            :onBeforeOk="onBeforeOk"
        >
            <span style="color:red;padding-right:10px">*</span>
            <a-select v-model="customer_number" allow-search :style="{width:'320px'}" placeholder="Please select" >
                <a-option v-for="(item,index) in sourceOptions" :key="index" :value="item.value">{{ item.label }}</a-option>
            </a-select>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js'; 
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { PriceListQueryForm } from './queryConfig/FinancialQuery'
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';

    const { t } = useI18n()
    const localeStore = useLocale()

    const queryForm = reactive(PriceListQueryForm)
    const customer_name = ref('')
    const showForm = ref(false)
    const visible = ref(false)
    const orderSource = reactive({})
    const sourceOptions = ref([])
    const modalTitle = ref(t('financial.selectChannels'))
    const customer_number = ref('')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'80',
                align:'center',
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'sku',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单类型',
                title:t('order.orderChannelType'),
                dataIndex: 'type',
                key:'type',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:140,
                slotName:'slot',
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'erp_item_name',
                key:'erp_item_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: '价目表名称',
                title:t('financial.priceListName'),
                dataIndex: 'price_list_name',
                key:'price_list_name',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:200
            },  
            {
                // title: '单价',
                title:t('order.unitPrice'),
                dataIndex: 'unit_price',
                key:'unit_price',
                align:'center',
                ellipsis:true,
                tooltip:true,
                width:140,
            },  
            // {
            //     // title: '客户名称',
            //     title:t('order.customerName'),
            //     dataIndex: 'customer_name',
            //     key:'customer_name',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },  
            {
                // title: '客户编码',
                title:t('customer.customerErpCode'),
                dataIndex: 'customer_number',
                key:'customer_number',
                align:'center',
                ellipsis:true,
                tooltip:true,
            }, 
        ],
        configs:{
            scroll:{
                // x:1000,
                y:480,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getPriceList()
                break;
            case 'reset':
                for(let key in queryForm.formData){
                    queryForm.formData[key] = ''
                }
                table.value.configs.pagination.current = 1
                getPriceList()
                break;
            case 'syncERPPrice':
                visible.value = true
                customer_number.value = ''
                break;
            case 'exportPriceData':
                exportPriceData()
                break;
        }
    }

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handlePressEnter = (val,item)=>{
        // console.log(val,item,'vvbnn')
        table.value.configs.pagination.current = 1
        getPriceList()
    }

    const handleInputClear = (val,item)=>{
        // console.log(val,item,'vvbnn2222')
        table.value.configs.pagination.current = 1
        getPriceList()
    }

    const search = (val)=>{
        table.value.configs.pagination.current = 1
        customer_name.value = val
        getPriceList()
    }

    const handleSelectChange = (val)=>{
        // console.log(val,'vvvv')
        table.value.configs.pagination.current = 1
        getPriceList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getPriceList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getPriceList()
    }

    // 获取列表
    const getPriceList = async ()=>{
        let param = {
            ...queryForm.formData,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await FinancialApi.getInstance().getPriceList(param,page_num,page_size)
        if(res.code == 0){
            table.value.datas = []
            res.data.records.forEach((i,index)=>{
                table.value.datas.push({
                    ...i,
                    No:index + 1,
                    unit_price: '€ ' + i.unit_price,
                    type_val:i.type,
                    type: i.type == 0? t('order.user') : t('order.dealer'),
                    source_val: i.source,
                    source: orderSource[i.source],
                })
            })
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 同步ERP价目表
    const onBeforeOk = async ()=>{
        if(customer_number.value == ''){
            Message.error(t('order.orderSource') + ' ' + t('base.noEmpty'))
            return false
        }

        table.value.configs.loading = true
        let res = await FinancialApi.getInstance().syncErpPriceList({erp_code: customer_number.value})
        if(res.code == 0){
            Message.success(t('base.syncSuccess'))
            getPriceList()
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 导出数据
    const exportPriceData = async()=>{
        let param = {
            ...queryForm.formData,
        }
        table.value.configs.loading = true
        let res = await FinancialApi.getInstance().exportPriceData(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('financial.exportPriceData2')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({status:'A'})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'source')
            item.options = []
            sourceOptions.value = []

            res.data.length > 0 && res.data.forEach(i=>{
                orderSource[i.id] = i.id == 1? 'Shopify' : i.customer_name

                item.options.push({
                    label:i.id == 1? 'Shopify' : i.customer_name,
                    value:i.id,
                })

                sourceOptions.value.push({
                    label:i.id == 1? 'Shopify' : i.customer_name,
                    value:i.customer_number,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU下拉数据
    const getSku = async ()=>{
        let res = await OrderApi.getInstance().getProductList({simple_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'sku')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.sku,
                    value:i.sku,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async()=>{
        await getOrderSource()
        getSku()
        getPriceList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

.alertBar{
    display: inline-block;
    width: fit-content;
    font-size:12px;
    font-weight: 600;
}

/deep/ .arco-alert{
    padding: 1px 15px;
    vertical-align: bottom;

    .arco-alert-icon,
    .arco-alert-body{
        display: inline-block;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-modal-body{
    text-align: center !important;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 3px 0;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-input-wrapper .arco-input[disabled] {
    -webkit-text-fill-color: #999;
}

/deep/ .arco-form-item-label-col{
    width:0 !important;
}

/deep/ button:focus, button:focus-visible{
    outline:none;
}
</style>